import React, { useId, useState } from "react";
import classnames from "classnames";

import ChevronIcon from "components/Icons/ChevronIcon";

type Props = {
  question?: string;
  answer?: string;
  initialShowPanel?: boolean;
  onClick?: () => void;
};

const FAQ = ({
  answer,
  initialShowPanel = false,
  onClick,
  question,
}: Props): JSX.Element => {
  const [showPanel, setShowPanel] = useState(initialShowPanel);
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    if (showPanel) {
      setShowPanel(false);
    } else {
      setShowPanel(true);
    }
  };
  const sectionId = useId();
  const buttonId = useId();

  return question && answer ? (
    <div className="faq-card accordion border border-solid border-light-grey rounded py-md px-lg bg-white mb-md">
      <div className="faq-card__question">
        <button
          aria-expanded={showPanel}
          aria-controls={sectionId}
          id={buttonId}
          className="items-center accordion__trigger flex justify-between w-full py-xs"
          onClick={handleClick}
        >
          <h3 className="faq-card__title accordion__title flex-grow font-bold text-left pr-xl heading--s">
            {question}
          </h3>
          <div className="accordion__icon text-green flex-none">
            <ChevronIcon direction="left" />
          </div>
        </button>
      </div>
      <div
        id={sectionId}
        aria-labelledby={buttonId}
        className={classnames("accordion-panel pt-xs", {
          hidden: !showPanel,
        })}
      >
        <div
          className="m-0 whitespace-pre-line"
          dangerouslySetInnerHTML={{ __html: answer }}
        />
      </div>
      <style jsx>{`
        .accordion__icon {
          transform: rotate(${showPanel ? 90 : -90}deg);
          transition-duration: 200ms;
          transition-property: transform;
        }
      `}</style>
    </div>
  ) : (
    <></>
  );
};

export default FAQ;
